import { TUNE } from './config';

/**
 * Computes a turn pattern: an array of action counts for upcoming player turns.
 * Each element represents one player-turn window:
 *   0 = enemy skips (not enough energy to act)
 *   1 = enemy acts once
 *   2+ = enemy acts multiple times (e.g. 2x speed enemies)
 *
 * Dot 0 is the current turn (right now). Dots 1+ are future player turns.
 */
export function computeTurnDots(
  currentEnergy: number,
  actorSpeed: number,
  playerSpeed: number,
  numDots: number = 4
): number[] {
  const { ACTION_COST } = TUNE;
  const energyPerPlayerTurn = actorSpeed * (ACTION_COST / playerSpeed);
  const dots: number[] = [];
  let energy = currentEnergy;

  for (let i = 0; i < numDots; i++) {
    if (i > 0) {
      energy += energyPerPlayerTurn;
    }

    let actions = 0;
    while (energy >= ACTION_COST) {
      actions++;
      energy -= ACTION_COST;
    }

    dots.push(actions);
  }

  return dots;
}
